import type {
  OnInit} from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';


@Component({
    selector: 'ppl-edit-email',
    templateUrl: './edit-email.component.html',
    styleUrls: ['./edit-email.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EditEmailComponent implements OnInit {
  @Input() user: EditEmailUser;
  @Output() edit = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  onEdit(event: MouseEvent) {
    this.edit.emit();
  }

}

export interface EditEmailUser {
  email: string;
  name?: string;
}
